import './style.scss';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.booom-reviews .reviews-swiper').forEach((swiperEl) => {
        const id = swiperEl.id;
        const section = swiperEl.closest('.booom-reviews');

        new Swiper(swiperEl, {
            modules: [Navigation, Autoplay],
            spaceBetween: 24,
            slidesPerView: 1.15,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: { slidesPerView: 1.1, spaceBetween: -10 },
                768: { slidesPerView: 1.4, spaceBetween: -10 },
                1024: { slidesPerView: 1.1, spaceBetween: -10 },
                1200: { slidesPerView: 1.2, spaceBetween: -10 },
                1300: { slidesPerView: 1.6, spaceBetween: -16 },
            },
            loop: true,
            navigation: {
                prevEl: `.${id}-prev`,
                nextEl: `.${id}-next`,
            },
        });
    });
});
